import { queryClient } from '@/lib/queryClient'

export function invalidateNotifications() {
  // Small delay to ensure backend transaction has committed, then force refetch
  setTimeout(() => {
    queryClient.refetchQueries({ queryKey: ['notifications'] })
    queryClient.refetchQueries({ queryKey: ['notifications', 'unreadCount'] })
  }, 150)
}
